import { render, staticRenderFns } from "./formView.vue?vue&type=template&id=f5632fd0&scoped=true&"
import script from "./formView.vue?vue&type=script&lang=js&"
export * from "./formView.vue?vue&type=script&lang=js&"
import style0 from "./formView.vue?vue&type=style&index=0&id=f5632fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5632fd0",
  null
  
)

export default component.exports